<div class="card mb-3">
    <div class="card-header d-flex flex-row justify-content-between">
        <h2 class="card-title mb-0">Game Log</h2>
    </div>
    <div class="p-3">
        <div class="row g-2 align-items-end mb-3">
            <div class="col-12 col-sm-6 col-md-auto">
                <label class="form-label">Date From</label>
                <input type="datetime-local" class="form-control" [(ngModel)]="data.date_from" />
            </div>
            <div class="col-12 col-sm-6 col-md-auto">
                <label class="form-label">Date To</label>
                <input type="datetime-local" class="form-control" [(ngModel)]="data.date_to" />
            </div>
            <div class="col-12 col-sm-6 col-md-auto">
                <label class="form-label">Player Code</label>
                <input type="text" class="form-control" [(ngModel)]="data.code" />
            </div>
            <div class="col-12 col-sm-6 col-md-auto">
                <label class="form-label">Player Mobile</label>
                <input type="text" class="form-control" [(ngModel)]="data.mobile" placeholder="Include Country Code" />
            </div>
            <div class="col-6 col-sm-4 col-md-auto">
                <label class="form-label">Match</label>
                <select class="form-select" [(ngModel)]="data.match">
                    <option value="exact">Exact</option>
                    <option value="approx">Approximate</option>
                </select>
            </div>
            <div class="col-12 col-sm-8 col-md">
                <label class="form-label">Game</label>
                <ng-select
                    bindLabel="name"
                    bindValue="id"
                    [items]="games"
                    [multiple]="true"
                    [clearable]="true"
                    [placeholder]="'Select Game'"
                    [(ngModel)]="data.game_id" >
                </ng-select>
            </div>
            <div class="col-12 col-md-auto d-flex align-items-end">
                <div class="form-check mb-2" title="Requires a Player Code or Mobile — shows this player's deposits & withdrawals inline with their bets">
                    <input class="form-check-input" type="checkbox" id="gl-include-deposit" [(ngModel)]="data.include_deposit" (change)="filter(1)" />
                    <label class="form-check-label" for="gl-include-deposit">Include Deposits 含存提</label>
                </div>
            </div>
            <div class="col-12 col-md-auto">
                <button class="btn btn-primary w-100" (click)="filter()">Filter</button>
            </div>
        </div>
        <div class="row" *ngIf="data.include_deposit && !data.code && !data.mobile">
            <div class="col-12">
                <div class="alert alert-warning py-2 mb-0 small">
                    Enter a <b>Player Code</b> or <b>Mobile</b> above to see that player's deposits &amp; withdrawals merged into the game log.
                </div>
            </div>
        </div>
    </div>
</div>

<div class="mb-3 card" *ngIf="!load && items.length > 0">
    <div class="card-header">
        <h3 class="mb-0 text-dark fw-bolder">Statistic</h3>
    </div>
    <div class="card-body p-3 d-flex flex-row flex-wrap d-flex-md-nowrap gap-3 align-items-center">
        <div class="gl-stat">
            <span class="gl-stat-label">Total Record</span>
            <span class="gl-stat-value">{{statistic.total ?? 0}}</span>
        </div>
        <div class="gl-stat">
            <span class="gl-stat-label">Total Bet</span>
            <span class="gl-stat-value">{{statistic.total_bet ?? 0 | number:'1.2-2'}}</span>
        </div>
        <div class="gl-stat">
            <span class="gl-stat-label">Total Win</span>
            <span class="gl-stat-value text-success">{{statistic.total_winloss ?? 0 | number:'1.2-2'}}</span>
        </div>
        <div class="gl-stat">
            <span class="gl-stat-label">Total Loss</span>
            <span class="gl-stat-value text-danger">{{statistic.total_loss ?? 0 | number:'1.2-2'}}</span>
        </div>
        <div class="gl-stat">
            <span class="gl-stat-label">Total Bonus</span>
            <span class="gl-stat-value">{{statistic.total_bonus ?? 0 | number:'1.2-2'}}</span>
        </div>
        <div class="gl-stat" *ngIf="data.include_deposit">
            <span class="gl-stat-label">Total Deposit 存款</span>
            <span class="gl-stat-value text-primary">{{statistic.total_deposit ?? 0 | number:'1.2-2'}}</span>
        </div>
        <div class="gl-stat" *ngIf="data.include_deposit">
            <span class="gl-stat-label">Total Withdraw 取款</span>
            <span class="gl-stat-value text-warning">{{statistic.total_withdraw ?? 0 | number:'1.2-2'}}</span>
        </div>
        <div class="gl-stat" *ngIf="data.include_deposit" title="Wallet balance at the end of this range — the running Balance column reconciles down to this figure.">
            <span class="gl-stat-label">Closing Balance 余额</span>
            <span class="gl-stat-value">{{statistic.closing_balance ?? 0 | number:'1.2-2'}}</span>
        </div>
        <nav>
            <ul class="pagination mb-0">
              <li class="page-item"><a class="page-link"(click)="filter(page_nat.current_page - 1)" *ngIf="page_nat.current_page - 1 >= 0"><</a></li>
              <li class="page-item" *ngFor="let page of page_nat.page_nat" [class.active]="page_nat.current_page + 1 == page" ><a class="page-link" (click)="filter(page)">{{page}}</a></li>
              <li class="page-item"><a class="page-link"(click)="filter(page_nat.current_page + 2)" *ngIf="page_nat.current_page + 2 <= page_nat.total_page">></a></li>
              <li>
                <input type="number" class="form-control form-control-sm h-100" style="width: 50px;" [(ngModel)]="page_nat.current_page" (change)="filter(page_nat.current_page)" />
              </li>
              <li class="d-flex flex-row align-items-center px-2">{{(page_nat.current_page ?? 0) * (page_nat.page_limit ?? 200) + 1 }} - {{(page_nat.current_page ?? 0) * (page_nat.page_limit ?? 200) + (page_nat.page_limit ?? 200)}}</li>
            </ul>
        </nav>
    </div>
</div>

<div class="card">
    <div class="card-body p-0">

        <ng-container *ngIf="!load && items.length == 0" >
            <h3 class="mb-0 px-3 py-3">No Data Available</h3>
        </ng-container>

        <ng-container *ngIf="load" >
            <div class="d-flex flex-row align-items-center justify-content-center p-3">
                <div class="loader"></div>
            </div>
        </ng-container>

        <div *ngIf="!load && items.length > 0">

            <!-- Read-through toolbar: instant in-page search + filters + legend -->
            <div class="gl-toolbar p-2 border-bottom">
                <div class="d-flex flex-row flex-wrap gap-2 align-items-center">
                    <div class="gl-search">
                        <input type="text" class="form-control form-control-sm"
                               placeholder="🔍 Search this page (player, mobile, game, txn/round ID)…"
                               [(ngModel)]="quickSearch" />
                    </div>
                    <select class="form-select form-select-sm w-auto" [(ngModel)]="statusFilter">
                        <option value="all">All Status</option>
                        <option value="1">Completed</option>
                        <option value="2">Pending</option>
                        <option value="9">Canceled</option>
                    </select>
                    <select class="form-select form-select-sm w-auto" [(ngModel)]="resultFilter">
                        <option value="all">All Results</option>
                        <option value="win">Player Win</option>
                        <option value="loss">Player Loss</option>
                        <option value="bonus">Bonus / Jackpot</option>
                    </select>
                    <button class="btn btn-sm btn-outline-secondary" (click)="resetView()">Reset</button>

                    <div class="ms-auto position-relative">
                        <button class="btn btn-sm btn-outline-secondary" (click)="showColumnPicker = !showColumnPicker">
                            Columns ({{visibleColCount}}/{{columnDefs.length}})
                        </button>
                        <div *ngIf="showColumnPicker" class="position-absolute bg-white border rounded shadow p-2" style="top: 36px; right: 0; z-index: 1000; min-width: 180px;">
                            <div *ngFor="let col of columnDefs" class="form-check">
                                <input class="form-check-input" type="checkbox" [id]="'gl-col-' + col.key" [(ngModel)]="visibleColumns[col.key]" />
                                <label class="form-check-label" [for]="'gl-col-' + col.key">{{col.label}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-row flex-wrap gap-3 align-items-center mt-2 small">
                    <span class="text-muted">Showing {{displayItems.length}} of {{items.length}} on this page</span>
                    <span class="gl-legend gl-playerwin">Player Win</span>
                    <span class="gl-legend gl-playerloss">Player Loss</span>
                    <span class="gl-legend gl-bonus">Bonus / Jackpot</span>
                    <span class="text-muted">Tip: click a column header to sort · click an ID to copy</span>
                </div>
            </div>

            <div class="gl-table-wrap">
            <table class="table table-sm table-hover align-middle mb-0 gl-table">
                <thead>
                    <tr>
                        <th *ngIf="col('no')">No</th>
                        <th *ngIf="col('player')" class="gl-sortable" (click)="toggleSort('code')">Player <span class="gl-sort">{{sortIcon('code')}}</span></th>
                        <th *ngIf="col('mobile')" class="gl-sortable" (click)="toggleSort('mobile')">Mobile <span class="gl-sort">{{sortIcon('mobile')}}</span></th>
                        <th *ngIf="col('game')" class="gl-sortable" (click)="toggleSort('game_name')">Game <span class="gl-sort">{{sortIcon('game_name')}}</span></th>
                        <th *ngIf="col('game_name')">Game Name</th>
                        <th *ngIf="col('player_game_id')">Player Game ID</th>
                        <th *ngIf="col('transaction_id')">Transaction ID</th>
                        <th *ngIf="col('round_id')">Round ID</th>
                        <th *ngIf="col('match')">Match / Event</th>
                        <th *ngIf="col('remark')">Remark</th>
                        <th *ngIf="col('bet')" class="border-start text-end gl-sortable gl-num" (click)="toggleSort('bet')">Bet <span class="gl-sort">{{sortIcon('bet')}}</span></th>
                        <th *ngIf="col('winloss')" class="border-start text-end gl-sortable gl-num" (click)="toggleSort('winloss')">Win/Loss (net) <span class="gl-sort">{{sortIcon('winloss')}}</span></th>
                        <th *ngIf="col('bonus')" class="border-start text-end gl-sortable gl-num" (click)="toggleSort('bonus')">Bonus/Jackpot <span class="gl-sort">{{sortIcon('bonus')}}</span></th>
                        <th *ngIf="col('wb_after')" class="border-start text-end gl-num"
                            [title]="data.include_deposit ? 'Running balance in statement order — this is the column that adds up down the page. Bets are listed at placement time but settle later, so the raw wallet snapshot cannot tally; this running total does.' : ''">{{ data.include_deposit ? 'Balance 余额' : 'Wallet After Bet' }}</th>
                        <th *ngIf="col('status')" class="border-start gl-sortable" (click)="toggleSort('status')">Status <span class="gl-sort">{{sortIcon('status')}}</span></th>
                        <th *ngIf="col('create_on')" class="gl-sortable" (click)="toggleSort('create_on')">Create On <span class="gl-sort">{{sortIcon('create_on')}}</span></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of displayItems; let i = index;">
                    <tr [ngClass]="resultClass(item)">
                        <td *ngIf="col('no')" class="text-muted">{{i + 1}}</td>
                        <td *ngIf="col('player')" class="fw-semibold">{{item.code}}</td>
                        <td *ngIf="col('mobile')">{{item.mobile}}</td>
                        <td *ngIf="col('game')">
                            <span *ngIf="isMovement(item)" class="fw-semibold">{{ mvLabel(item) }}</span>
                            <ng-container *ngIf="!isMovement(item)">{{item.game_name}}<span class="text-muted" *ngIf="item.platform"> ({{item.platform}})</span></ng-container>
                        </td>
                        <td *ngIf="col('game_name')">{{ isMovement(item) ? '—' : item.supplier_game_name }}</td>
                        <td *ngIf="col('player_game_id')">{{ isMovement(item) ? '—' : item.player_username }}</td>
                        <td *ngIf="col('transaction_id')">
                            <span class="gl-id" [title]="item.transaction_id" (click)="copyId(item.transaction_id)">
                                {{item.transaction_id}}
                                <span class="gl-copied" *ngIf="copiedValue && copiedValue === ('' + item.transaction_id)">copied</span>
                            </span>
                        </td>
                        <td *ngIf="col('round_id')">
                            <span *ngIf="isMovement(item)" class="text-muted">—</span>
                            <span *ngIf="!isMovement(item)" class="gl-id" [title]="item.round_id" (click)="copyId(item.round_id)">
                                {{item.round_id}}
                                <span class="gl-copied" *ngIf="copiedValue && copiedValue === ('' + item.round_id)">copied</span>
                            </span>
                        </td>
                        <td *ngIf="col('match')">
                            <span *ngIf="isMovement(item)" class="text-muted">{{ item.remark || '—' }}</span>
                            <ng-container *ngIf="!isMovement(item)">
                                <span *ngIf="betOutcome(item) as oc" class="badge me-1" [ngClass]="oc.cls" [title]="'Bet outcome'">{{ oc.label }}</span>
                                <ng-container *ngIf="hasDetail(item); else noMatch">
                                    <span class="gl-match" (click)="toggleExpand(item)" title="Click to view all selections">
                                        <span class="gl-caret">{{ isExpanded(item) ? '▾' : '▸' }}</span>
                                        {{ matchSummary(item) }}
                                    </span>
                                </ng-container>
                                <ng-template #noMatch><span class="text-muted">—</span></ng-template>
                            </ng-container>
                        </td>
                        <td *ngIf="col('remark')" style="font-size: 10px; max-width: 320px;">
                            <span *ngIf="isMovement(item)" class="text-muted">—</span>
                            <ng-container *ngIf="!isMovement(item)">
                                <span *ngIf="item.game_remark">{{item.game_remark}}</span>
                                <span *ngIf="!item.game_remark" class="text-muted">—</span>
                            </ng-container>
                        </td>
                        <td *ngIf="col('bet')" class="border-start text-end gl-num">
                            <span *ngIf="isMovement(item)" class="text-muted">—</span>
                            <ng-container *ngIf="!isMovement(item)">{{item.bet | number:'1.2-2'}}</ng-container>
                        </td>
                        <td *ngIf="col('winloss')" class="border-start text-end gl-num"
                            [class.text-success]="!isMovement(item) && netOf(item) > 0"
                            [class.text-danger]="!isMovement(item) && netOf(item) < 0"
                            [class.text-primary]="item.row_type === 'deposit'"
                            [class.text-warning]="item.row_type === 'withdraw'"
                            [title]="isMovement(item) ? (item.row_type === 'withdraw' ? 'Withdrawal' : 'Deposit') : ('Gross payout: ' + (item.winloss | number:'1.2-2'))">
                            <ng-container *ngIf="isMovement(item)">{{ mvAmount(item) > 0 ? '+' : '' }}{{ mvAmount(item) | number:'1.2-2' }}</ng-container>
                            <ng-container *ngIf="!isMovement(item)">{{netOf(item) | number:'1.2-2'}}</ng-container>
                        </td>
                        <td *ngIf="col('bonus')" class="border-start text-end gl-num">{{ isMovement(item) ? '—' : (item.bonus | number:'1.2-2') }}</td>
                        <td *ngIf="col('wb_after')" class="border-start text-end gl-num">
                            <!-- Feed/movement mode: show the tally-able running balance (statement order).
                                 The raw "wallet after bet" can't add up because a winning bet is listed at
                                 placement time but carries its later settle-time balance. The running total
                                 IS the figure that reconciles down to the closing balance; the true wallet
                                 balance at that instant is kept in the tooltip. -->
                            <ng-container *ngIf="item.running_balance != null; else rawBal">
                                <span class="fw-semibold"
                                    [title]="'Running balance (statement order) — adds up down the page to the closing balance. True wallet balance at this moment: ' + (item.wallet_balance | number:'1.2-2') + (isMovement(item) ? '' : '. Bets are listed at placement time but settle later, so the running total — not the raw snapshot — is what tallies.')">{{item.running_balance | number:'1.2-2'}}</span>
                            </ng-container>
                            <ng-template #rawBal><span>{{item.wallet_balance | number:'1.2-2'}}</span></ng-template></td>
                        <td *ngIf="col('status')" class="border-start">
                            <span *ngIf="isMovement(item)" class="badge" [ngClass]="{'bg-primary': item.row_type === 'deposit', 'bg-warning text-dark': item.row_type === 'withdraw'}">{{ item.row_type === 'withdraw' ? 'Withdraw' : 'Deposit' }}</span>
                            <span *ngIf="!isMovement(item)" class="badge" [ngClass]="{'bg-success': item.status == 1, 'bg-warning text-dark': item.status == 2, 'bg-secondary': item.status == 9}">{{statusUpdate(item.status)}}</span>
                        </td>
                        <td *ngIf="col('create_on')" class="text-nowrap">{{item.create_on | date: "dd-MM-yyyy HH:mm:ss"}}</td>
                    </tr>
                    <tr *ngIf="hasDetail(item) && isExpanded(item)" class="gl-detail-row">
                        <td [attr.colspan]="visibleColCount">
                            <div class="gl-detail">
                                <div class="gl-detail-head">
                                    {{ item.game_detail.sportName }}
                                    <span *ngIf="item.game_detail.betType"> · {{ item.game_detail.betType }}</span>
                                    <span *ngIf="item.game_detail.totalOdds"> · total odds {{ item.game_detail.totalOdds }}</span>
                                    <span *ngIf="item.game_detail.legs.length > 1"> · {{ item.game_detail.legs.length }} legs (parlay)</span>
                                </div>
                                <div class="gl-leg" *ngFor="let leg of item.game_detail.legs">
                                    <div class="gl-leg-event">
                                        <span class="text-muted" *ngIf="leg.leagueName">{{ leg.leagueName }} · </span>
                                        <span class="fw-semibold">{{ leg.eventName || (leg.homeTeam + ' vs ' + leg.awayTeam) }}</span>
                                        <span class="badge bg-danger ms-1" *ngIf="leg.live">LIVE</span>
                                        <span class="text-muted ms-1" *ngIf="leg.liveScore">({{ leg.liveScore }})</span>
                                    </div>
                                    <div class="gl-leg-sel">
                                        {{ legSelection(leg) }}
                                        <span class="ms-2" [ngClass]="legResultClass(leg)" *ngIf="leg.legStatus">[{{ leg.legStatus }}]</span>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </ng-container>
                    <tr *ngIf="displayItems.length == 0">
                        <td [attr.colspan]="visibleColCount" class="text-center text-muted py-3">No rows match your search / filter on this page.</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="gl-foot">
                        <td [attr.colspan]="visibleColCount - (col('bet') ? 1 : 0) - (col('winloss') ? 1 : 0) - (col('bonus') ? 1 : 0) - (col('wb_after') ? 1 : 0) - (col('status') ? 1 : 0) - (col('create_on') ? 1 : 0)" class="text-end fw-bold">Visible Total</td>
                        <td *ngIf="col('bet')" class="text-end gl-num fw-bold">{{sum('bet') | number:'1.2-2'}}</td>
                        <td *ngIf="col('winloss')" class="text-end gl-num fw-bold">{{sum('winloss') | number:'1.2-2'}}</td>
                        <td *ngIf="col('bonus')" class="text-end gl-num fw-bold">{{sum('bonus') | number:'1.2-2'}}</td>
                        <td *ngIf="col('wb_after')"></td>
                        <td *ngIf="col('status')"></td>
                        <td *ngIf="col('create_on')"></td>
                    </tr>
                </tfoot>
            </table>
            </div>
        </div>
    </div>
</div>
